'use strict';

// Constructor
var Header = function() {
  var header = $('.header');
  var headerAd = $('.header__ad');
  var body = $('body');
  var menuOpen = $('.header__hamburguer');
  var menuClose = $('.header__internal-menu__close');
  var nav = $('.header__bottom');
  var internalMenu = $('.header__internal-menu__wrapper');
  var expandTeams = $('.-expand button');
  var teamsList = $('.escudos');

  menuOpen.on('click', function(){
    header.toggleClass('-open');
    body.toggleClass('-hideOverflow');
    updateNavPos();
  });

  function updateNavPos() {
    var top = header.position().top - $(document).scrollTop() > 0 ? header.position().top - $(document).scrollTop() : 0;
    nav.css('top', top + header.outerHeight());
    internalMenu.css('height', $(window).height() - (top + header.outerHeight()));
  }

  expandTeams.on('click', function(){
    teamsList.toggleClass('-expanded');
  });
 
  menuClose.on('click', function(){
    header.removeClass('-open');
    body.removeClass('-hideOverflow');
  });

  $(document).on('scroll', function() {
    updateNavPos();

    var scroll = $(window).scrollTop();

    if (scroll >= headerAd.outerHeight() - 10 || scroll >= headerAd.outerHeight() + 10) {
      header.addClass('-offtop');
      setTimeout(() => {
        nav.addClass('-offtop');
      }, 500);
    } else {
      nav.removeClass('-offtop');
      header.removeClass('-offtop');
    }
  });


  // Score Board
  var scoreBoard = $('.eg-scoreboard');

  if (scoreBoard) {
    var slideLeft = $('.eg-scoreboard__nav--left');
    var slideRight = $('.eg-scoreboard__nav--right');
    var container = $('.eg-scoreboard__content');
    var list = $('.eg-scoreboard__list');

    slideLeft.on('click', function() {
      console.log('left');
      slide('left');
    });

    slideRight.on('click', function() {
      console.log('right');
      slide('right');
    });

    function slide(direction){
      if(direction == 'left'){
        container.animate({scrollLeft: '-=50'}, 300);
      } else {
        container.animate({scrollLeft: '+=50'}, 300);
      }
    }  
  }

  // Hemeroteca
  var hemeroteca = $('.hemeroteca');
  var hemerotecaNavItems = $('.hemeroteca__item');
  var hemerotecaContents = $('.hemeroteca__content');

  if (hemeroteca) {
    hemerotecaNavItems.on('click', function() {
      var target = $(this).data('index');

      hemerotecaNavItems.removeClass('-active');
      hemerotecaContents.removeClass('-active');

      $(this).addClass('-active');
      hemerotecaContents.filter(function() {
        return $(this).data('hemeroteca') === target
      }).addClass('-active');
    });
  }

  // Gallery

  var egGallery = $('.eg-gallery');
  var egGalleryNavItems = $('[data-for]');
  var egGalleryContents = $('[data-media]');

  if (egGallery) {
    egGalleryNavItems.on('click', function() {
      var target = $(this).data('for');

      egGalleryNavItems.removeClass('js-active');
      egGalleryContents.removeClass('js-active');

      $(this).addClass('js-active');
      egGalleryContents.filter(function() {
        return $(this).data('media') === target
      }).addClass('js-active');

      $('.eg-gallery__media').slick('reinit');
    
      $('.eg-gallery__slides').slick('reinit');
    });

    $('.eg-gallery__media').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.eg-gallery__slides'
    });
  
    $('.eg-gallery__slides').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.eg-gallery__media',
      dots: false,
      centerMode: true,
      focusOnSelect: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

};

module.exports = Header;
